import api from './axiosConfig.js'

export const dashboardApi = {
  // Dashboard stats
  getAllStats: () =>
    api.get('/dashboard/get-all-stats'),

  getTodayStats: () =>
    api.get('/dashboard/today'),

  getMonthlyOverview: () =>
    api.get('/dashboard/overview'),

  getDepartmentWiseAttendance: () =>
    api.get('/org/attendance/stats/department-wise-today'),

  getDepartmentAttendanceSummary: () =>
    api.get('/org/dashboard/department-attendance'),

  getAttendanceOverview: (params) =>
    api.get('/org/dashboard/attendance-overview', { params }),

  getMonthAttendanceChart: () =>
    api.get('/org/dashboard/month-attendance-chart'),

  getHourlyCheckins: () =>
    api.get('/org/attendance/stats/hourly-checkins'),

  getDashboardStats: () => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/org/dashboard/stats', {
      headers: {
        'X-Org-ID': orgId
      }
    })
  },

  // Audit logs
  getAuditLogs: (params = {}) =>
    api.get('/audit-logs', { params }),

  // Employee Dashboard
  getUpcomingLeaves: (employeeId, orgId) =>
    api.get('/employee/dashboard/upcoming-leaves', {
      headers: {
        'X-Employee-ID': employeeId,
        'X-Org-ID': orgId
      }
    }),
}